module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAM1BMVEUAAAAmiOMmiuMniOInieInieInieJIm+dLnedSoehUouhZpOlapemUxfHs9fzt9f3////XH99pAAAABnRSTlMASUrk5udXTd49AAAAeUlEQVQ4y+3VvQ6AIAwEYH/wCii9vv/TOjgRItY4ys3f0CsJnaaRJnNAJ2GucNcCocKAdQL8Ee/t0o43eP/v6saeb3DJNGMuLpwQyYjkwhohgqi+mVUAUWdBCiD0YV5j0FtQ3QVLUjOm8vlRHj7GrcLL1rPrMo5SmxO9iTIy2nv2aAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/ct_b@2x.png
// module id = Opmq
// module chunks = 0